import { useState } from "react";
import { Button } from "src/elements/buttons";
import { Header } from "src/elements/header";
import { Input } from "src/elements/numeric-input";
import { Text } from "src/elements/text";
import { FromDisplayNumber, ToDisplayNumber } from "src/Logic/Helpers/number-helpers";
import styled from "styled-components"


const Div = styled.div`
    margin-top: ${ props => props.theme.spacing.extraLarge };
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    .wagerText { 
        color: var(--white, #FFF);
        text-align: center;
        font-family: var(--font-circular);
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 140%; /* 19.6px */
        letter-spacing: 0.14px;
        text-transform: capitalize;
    }

    .balanceText {
        color: var(--yellow, #E6D2A6);
        text-align: center;
        font-family: var(--font-circular);
        font-size: 44px;
        font-style: normal;
        font-weight: 700;
        line-height: 110%; /* 48.4px */
        text-transform: capitalize;
    }
`;

type Props = {
    makeWager: ( value: number ) => void,
    balance:  number,
}

export const  WagerScreen = ({ makeWager, balance } : Props ) => {

    const [ wagerValue, setWagerValue ] = useState<number>();
    const [ isError, setIsError ] = useState( false );

    const handleWagerChange = ( event: React.ChangeEvent<HTMLInputElement> ) => {
        if (event.target.value !== undefined)
        {
            const wagerNumber = FromDisplayNumber(event.target.value);

            if( wagerNumber > balance || wagerNumber % 1 !== 0 || wagerNumber < 0)
                setIsError( true )
            else
                setIsError( false )

            setWagerValue(wagerNumber);
        }
    }

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        if (wagerValue !== undefined && !isError) {
            makeWager(wagerValue);
        }
    };

    return (
        <>
            <Header isPlayerContext={true} />
            <Div>
                <Text className = "wagerText">your bank balance:</Text>
                <Text className = "mrBottomEtraLarge balanceText"><b>{`$${ToDisplayNumber(balance)}`}</b></Text>
                <form onSubmit={handleSubmit}>
                    <Input
                        error = { isError ? 'incorrect wager amount.' : undefined }
                        onChange = { handleWagerChange }
                        className = "mrBottomMain"
                        label = "How much would you like to wager?"
                        placeholder = "Enter Wager"/>
                    <Button
                        disabled = { wagerValue === undefined || isError }
                        variant="player"
                        type="submit">Enter</Button>
                </form>
            </Div>
        </>
    )
}